import cx from 'classix';
import { useTranslations } from 'next-intl';
import {
  FaApple,
  FaCircleCheck,
  FaEnvelope,
  FaGoogle,
  FaHouseUser,
  FaLinkedin,
  FaMobileButton,
  FaSquareFacebook,
  FaSquareInstagram,
  FaUser,
} from 'react-icons/fa6';

import {
  type Listing,
  type ListingWithUser,
} from '@/features/listing/types/listing-types';
import { VerificationStatus } from '@/features/user/types/user-id-verification-types';

import styles from './listing-verifications.module.scss';

interface ListingVerificationsProps {
  userVerifications: ListingWithUser['user']['verifications'];
  isAddressVerified?: Listing['addressVerificationStatus'];
  isProfilePage?: boolean;
  showOnlyImportant?: boolean;
  showText?: boolean;
}

export default function ListingVerifications(props: ListingVerificationsProps) {
  const {
    isAddressVerified,
    isProfilePage,
    showOnlyImportant,
    showText = true,
    userVerifications,
  } = props;

  const translationsVerifications = useTranslations('global.verifications');

  return (
    <div
      className={cx(
        styles.listingVerifications,
        isProfilePage && styles.listingVerifications__isProfilePage,
        !showText && styles.listingVerifications__withoutText,
      )}
    >
      {userVerifications.id?.status === VerificationStatus.Passed && (
        <div className={styles.listingVerifications_item}>
          <div className={styles.listingVerifications_status}>
            <FaCircleCheck className={styles.listingVerifications_checked} />
            <FaUser className={styles.listingVerifications_icon} />
          </div>

          {showText && (
            <p className={styles.listingVerifications_text}>
              {translationsVerifications('id-checked')}
            </p>
          )}
        </div>
      )}

      {isAddressVerified === VerificationStatus.Passed && (
      <div className={styles.listingVerifications_item}>
        <div className={styles.listingVerifications_status}>
          <FaCircleCheck className={styles.listingVerifications_checked} />
          <FaHouseUser className={styles.listingVerifications_icon} />
        </div>

        {showText && (
        <p className={styles.listingVerifications_text}>
          {translationsVerifications('address-checked')}
        </p>
        )}
      </div>
      )}

      {userVerifications.email && (
      <div className={styles.listingVerifications_item}>
        <div className={styles.listingVerifications_status}>
          <FaCircleCheck className={styles.listingVerifications_checked} />
          <FaEnvelope className={styles.listingVerifications_icon} />
        </div>

        {showText && (
        <p className={styles.listingVerifications_text}>
          {translationsVerifications('email-validated')}
        </p>
        )}
      </div>
      )}

      {userVerifications.phone && (
      <div className={styles.listingVerifications_item}>
        <div className={styles.listingVerifications_status}>
          <FaCircleCheck className={styles.listingVerifications_checked} />
          <FaMobileButton className={styles.listingVerifications_icon} />
        </div>

        {showText && (
        <p className={styles.listingVerifications_text}>
          {translationsVerifications('phone-validated')}
        </p>
        )}
      </div>
      )}

      {!showOnlyImportant && (
      <>
        {userVerifications.apple && (
        <div className={styles.listingVerifications_item}>
          <div className={styles.listingVerifications_status}>
            <FaCircleCheck className={styles.listingVerifications_checked} />
            <FaApple className={styles.listingVerifications_icon} />
          </div>

          {showText && (
          <p className={styles.listingVerifications_text}>
            Apple
            {' '}
            {translationsVerifications('validated')}
          </p>
          )}
        </div>
        )}

        {userVerifications.google && (
        <div className={styles.listingVerifications_item}>
          <div className={styles.listingVerifications_status}>
            <FaCircleCheck className={styles.listingVerifications_checked} />
            <FaGoogle className={styles.listingVerifications_icon} />
          </div>

          {showText && (
          <p className={styles.listingVerifications_text}>
            Google
            {' '}
            {translationsVerifications('validated')}
          </p>
          )}
        </div>
        )}

        {userVerifications.facebook && (
        <div className={styles.listingVerifications_item}>
          <div className={styles.listingVerifications_status}>
            <FaCircleCheck className={styles.listingVerifications_checked} />
            <FaSquareFacebook className={styles.listingVerifications_icon} />
          </div>

          {showText && (
          <p className={styles.listingVerifications_text}>
            Facebook
              {translationsVerifications('validated')}
          </p>
          )}
        </div>
        )}

        {userVerifications.instagram && (
        <div className={styles.listingVerifications_item}>
          <div className={styles.listingVerifications_status}>
            <FaCircleCheck className={styles.listingVerifications_checked} />
            <FaSquareInstagram className={styles.listingVerifications_icon} />
          </div>

          {showText && (
          <p className={styles.listingVerifications_text}>
            Instagram
            {translationsVerifications('validated')}
          </p>
          )}
        </div>
        )}

        {userVerifications.linkedIn && (
        <div className={styles.listingVerifications_item}>
          <div className={styles.listingVerifications_status}>
            <FaCircleCheck className={styles.listingVerifications_checked} />
            <FaLinkedin className={styles.listingVerifications_icon} />
          </div>

          {showText && (
          <p className={styles.listingVerifications_text}>
            LinkedIn
            {translationsVerifications('validated')}
          </p>
          )}
        </div>
        )}
      </>
      )}

    </div>
  );
}
